import React from 'react';
const render =() => {
  require('./app-renderer')
};
render();